<template>
  <v-col cols="3">
    {{ $t('login.wait') }}
    <v-progress-linear indeterminate></v-progress-linear>
  </v-col>
</template>

<script>
import Mixins from '@/mixins/app_init'
import events from 'Store/events'
import api from '@/api'
import Session from '@/api/session'
import EmbeddedLocalStorage from '@/api/embedded'
import ChatLocalStorage from '@/api/chat'
import VueCookies from 'vue-cookies'
import LocalStorage from 'Store/class/local_storage'

export default {
  name: 'login-embedded',
  mixins: [Mixins],
  mounted () {
    Session.clear()
    const urlParams = new URLSearchParams(window.location.search)
    const embedded = urlParams.get('embedded')
    const cloudId = urlParams.get('cloud_id')
    const cloudUsername = urlParams.get('cloud_username')
    const cloudPassword = urlParams.get('cloud_password')
    const language = urlParams.get('language') || 'en-US'
    EmbeddedLocalStorage.set(embedded === 'true')
    EmbeddedLocalStorage.setData({
      cloudId: cloudId,
      cloudUsername: cloudUsername,
      cloudPassword: cloudPassword,
      language: language
    })
    ChatLocalStorage.setSmsFilters([])
    // login from clearly anywhere
    const params = {
      cloud_id: cloudId,
      cloud_username: cloudUsername,
      cloud_password: cloudPassword
    }
    api.embeddedLogin(params).then(resp => {
      this.dbg(resp)
      this.updateLocale(language)
      this.initCallpanel() // function in mixins
    }).catch(err => {
      const error = err.response || err
      this.dbg(error)
      events.pubError(this.$t('login.error.oauth2') + ': ' + err)
      this.$router.push({ name: 'login' })
    })
  },
  methods: {
    updateLocale (locale) {
      this.$i18n.locale = locale
      VueCookies.set('locale', locale)
      LocalStorage.setLocale(locale)
    }
  }
}
</script>

<style scoped>
</style>
